import { createRoutine } from 'redux-saga-routines';

export const fetchGoogleCalendarMetadata = createRoutine(
  'FETCH_GOOGLE_CALENDAR_METADATA'
);
export const connectGoogleCalendar = createRoutine('CONNECT_GOOGLE_CALENDAR');
export const reconnectGoogleCalendar = createRoutine(
  'RECONNECT_GOOGLE_CALENDAR'
);
export const disconnectGoogleCalendar = createRoutine(
  'DISCONNECT_GOOGLE_CALENDAR'
);
